<template>
<!-- 我的工单 -->
  <div class="content">
    <!-- header -->
    <div class="con_header">
      <span class="header_title">我的工单</span>
      <el-input v-model="searchValue" placeholder="按照问题描述搜索" size="small" style="width:250px">
        <template #suffix>
            <i class="el-input__icon el-icon-search"></i>
        </template>
      </el-input>
    </div>
    <!-- 创建按钮 -->
    <div class="create_button" @click="createWorkOrder">创建工单</div>
    <!-- table -->
    <div class="table">
      <el-table
        :data="workTableData"
        :header-cell-style="{background:'rgba(233, 239, 255, 1)',color:'#2A2A2A','text-align':'center'}"
        :cell-style="{'text-align':'center'}"
        style="width: 100%">
        <el-table-column
          prop="description"
          label="问题描述">
        </el-table-column>
        <el-table-column
          prop="id"
          label="工单编号">
        </el-table-column>
        <el-table-column
          label="问题类型">
          <template slot-scope="scope">{{ scope.row.questionType }}</template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间">
        </el-table-column>
        <el-table-column
          label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0">生效中</span>
            <span v-if="scope.row.status == 1">已结束</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="address"
          label="操作">
          <template slot-scope="scope">
            <span class="delete_btn" @click="deleteRow(scope.row)">删除</span>
            <span v-if="scope.row.status == 0" class="vertical_bar">|</span>
            <span v-if="scope.row.status == 0" class="delete_btn" @click="finishWorkorder(scope.row)">结束</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { queryTicketByUserID, queryAllTicketCategory, queryQuestionTypeByTicketCategoryId, deleteTicket, endTicket } from '@/api/console/supportServices.js'
import token from '@/utils/token.js'
export default {
  data() {
    return {
      searchValue :'',
      tableData: [],
      workTableData: [],
      firstStepList: [],
      secondStepList: []
    }
  },
  created() {
    this.getData();
  },
  watch: {
	  //监听路由地址的改变
	  $route:{
	      immediate: true,
	      handler() {
	        this.getData();
	      }
	  }
	},
  methods: {
    async getData() {
      let userId = token.getUser().id;
      let res = await queryTicketByUserID(userId);//查工单列表
      this.tableData = res.data.list;
      let firstStepRes = await queryAllTicketCategory();//查问题所属产品列表
      this.firstStepList = firstStepRes.data.list;
      for(let i = 0; i < this.tableData.length; i++) {
        for (let j = 0; j < this.firstStepList.length; j++) {
          if (this.tableData[i].ticketCategoryId = this.firstStepList[j].id) {
            this.tableData[i].ticketCategory = this.firstStepList[j].name;
            let res = await queryQuestionTypeByTicketCategoryId(this.firstStepList[j].id);
            this.secondStepList = res.data.list;
            for (let index = 0; index < this.secondStepList.length; index++) {
              if (this.tableData[i].questionTypeId = this.secondStepList[index].id) {
                this.tableData[i].questionType = this.secondStepList[index].name;
              }
            }
          }
        }
      }
      this.workTableData = this.tableData;
      // console.log(this.workTableData);
    },
    //跳转到创建工单页面
    createWorkOrder() {
      this.$router.push({path: '/supportServices', query:{ index: 0 }});
    },
    //删除行
    deleteRow(item) {
      let ticketId = item.id;
      deleteTicket(ticketId).then(() => {
        this.$message.success('删除成功！');
        this.getData();
      })
    },
    //结束工单
    finishWorkorder(item) {
      let ticketId = item.id;
      endTicket(ticketId).then(() => {
        this.$message.success('已结束工单！');
        this.getData();
      })
    },
  }
}
</script>

<style lang="scss" scoped="scoped">
.content {
  padding: 20px;
  margin-top: 20px;
  border: 1px solid #E5E5E5;
  .con_header {
    .header_title {
      color: #4F4F4F;
    }
    .el-input {
      float: right;
    }
  }
  .create_button {
    width: 146px;
    height: 32px;
    margin-top: 20px;
    background-color: #537EEE;
    font-size: 12px;
    color: #fff;
    text-align: center;
    line-height: 32px;
  }
  .create_button:hover {
    cursor: pointer;
    background-color: #6089F3;
  }
  // table
  .table {
    border: 1px solid #E5E5E5;
    border-top: none;
    border-bottom: none;
    .el-table {
      margin-top: 20px;
      font-size: 12px;
      /deep/ th {
          padding: 4px;
          font-weight: 400;
      }
      /deep/ td {
          padding: 10px;
      }
      /deep/ .cell {
        overflow: visible;
      }
    }
    .delete_btn { 
      color: #557FEB;
    }
    .delete_btn:hover {
      cursor: pointer;
      text-decoration: underline;
    }
    .vertical_bar {
      margin: 0 10px;
      color: #E5E5E5;
    }
  }
}
</style>